import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/cadastro',
    name: 'Cadastro',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "cadastro" */ '../views/Cadastro.vue')
  },
  {
    path: '/usuario',
    name: 'Usuario',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "usuario" */ '../views/Usuario.vue')
  },
  {
    path: '/contato',
    name: 'Contato',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "contato" */ '../views/Contato.vue')
  },
  {
    path: '/cidade',
    name: 'Cidade',
    meta:{requiresAuth:true},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "cidade" */ '../views/Cidade.vue')
  },
  {
    path: '/edificio',
    name: 'Edificio',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "edificio" */ '../views/Edificio.vue')
  },
  {
    path: '/busca',
    name: 'Busca',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "busca" */ '../views/Busca.vue')
  },
  {
    path: '/edicao/:id',
    name: 'Edicao',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "edicao" */ '../views/Cadastro.vue')
  },
  {
    path: '/lead',
    name: 'Lead',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "lead" */ '../views/Leads.vue')
  },
  {
    path: '/lead/:id',
    name: 'Lead',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "lead" */ '../views/Leads.vue')
  },
  {
    path: '/buscaLeads',
    name: 'BuscaLead',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "lead" */ '../views/BuscaLeads.vue')
  },
  {
    path: '/leadLocacao',
    name: 'LeadLocacao',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "leadLocacao" */ '../views/LeadsLocacao.vue')
  },
  {
    path: '/leadLocacao/:id',
    name: 'LeadLocacao',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "leadLocacao" */ '../views/LeadsLocacao.vue')
  },
  {
    path: '/buscaLeadsLocacao',
    name: 'BuscaLeadLocacao',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "leadLocacao" */ '../views/BuscaLeadsLocacao.vue')
  },
  {
    path: '/criarProposta',
    name: 'CriarProposta',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "propostas" */ '../views/CriarProposta.vue')
  },
  {
    path: '/propostas',
    name: 'Propostas',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "propostas" */ '../views/Propostas.vue')
  },
  {
    path: '/locacao',
    name: 'Locacao',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "locacao" */ '../views/Locacao.vue')
  },
  {
    path: '/locacao/:id',
    name: 'Locacao',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "locacao" */ '../views/Locacao.vue')
  },
  {
    path: '/buscaLocacoes',
    name: 'BuscaLocacoes',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "locacao" */ '../views/BuscaLocacoes.vue')
  },
  {
    path: '/iptuClientes/:id',
    name: 'IPTUclientes',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "locacao" */ '../views/IPTUclientes.vue')
  },
  {
    path: '/seguroFianca/:id',
    name: 'SeguroFianca',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "locacao" */ '../views/SeguroFianca.vue')
  },
  {
    path: '/boletos/:id',
    name: 'Boletos',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "locacao" */ '../views/Boletos.vue')
  },
  {
    path: '/edicaoBoleto/:pasta/:id',
    name: 'EdicaoBoleto',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "locacao" */ '../views/EdicaoBoleto.vue')
  },
  {
    path: '/repasses/:id',
    name: 'Repasses',
    meta:{requiresAuth:true},
    component: () => import(/* webpackChunkName: "locacao" */ '../views/Repasses.vue')
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to,from,next) => {
  
  if(to.matched.some(record => record.meta.requiresAuth)){
   
    let user =  sessionStorage.getItem('imobiliaria');
    
    
    if(user == null){
     router.push("/");
    }else{
      next();
    }

  }else{
    next();
  }

});

export default router
